import { $post } from '@/utils/request';
import servers from '../servers';

/**
 * @description: expandInfo 类型（可能是字符串或对象）
 */
export interface ExpandInfo {
  appCode?: string;
  digitalStaffId?: string;
  agiChatChannel?: string;
  external?: string;
  modelURL?: string;
  tenantDomain?: string;
  title?: string;
  tenantLogo?: string;
}

/**
 * @description: 租户相关接口返回数据类型
 */
export interface TenantInfo {
  tenantId: string;
  tenantName: string;
  expandInfo?: ExpandInfo | string;
}

export interface CurrentTenantInfo {
  tenantId: string;
  mid: string;
  tenantName: string;
  expandInfo?: ExpandInfo | string;
}

export interface SelectTenantResponse {
  currentTenant: CurrentTenantInfo;
  tenantList: TenantInfo[];
}

/**
 * @description: 获取租户列表并选择租户
 */
export const selectTenantRequest = (tenantId?: string) => $post<ResponseData<SelectTenantResponse>>(
  `${servers.base}/api/v1/tenant/selectTenant`,
  // eslint-disable-next-line no-negated-condition
  tenantId !== undefined ? { tenantId } : undefined
);
